import { http, HttpResponse } from 'msw'

import { allManagers } from 'app/mocks/data/park/managers'

import {
    api,
    isNumeric,
    SEARCH_PARAM_LIMIT,
    SEARCH_PARAM_OFFSET,
} from 'app/utils/constants'

import { PriceTablesRequest } from 'app/types/catalogue/priceTable'

export const getAllPriceTables = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.catalogue.priceTables.LIST}`,
    ({ request }) => {
        const { searchParams } = new URL(request.url)
        const limitQuery = searchParams.get(SEARCH_PARAM_LIMIT)
        const offsetQuery = searchParams.get(SEARCH_PARAM_OFFSET)

        const priceTables = []

        for (const manager of allManagers) {
            priceTables.push({
                ...manager,
                client: manager,
            })
        }

        // Pagination
        const limit = isNumeric(limitQuery) ? Number(limitQuery) : 10
        const offset = isNumeric(offsetQuery) ? Number(offsetQuery) : 0

        const limitArray =
            priceTables.length > limit ? offset + limit : priceTables.length

        const results = priceTables.slice(offset, limitArray)

        const next =
            offset + results.length < priceTables.length ? 'again' : undefined

        return HttpResponse.json<PriceTablesRequest>({
            next,
            results,
        })
    },
)
